import type { FaireProductEntity } from "../../entity_types/product";

export const p_exanbuy8u7: FaireProductEntity = {
  token: "p_exanbuy8u7",
  type: "product",
  name: "Endless Gratitude",
  brandToken: "b_sskrdryawp",
  brandName: "Someday Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/84f9a478ed5a91088d3d79fd1bd8a190f01eab1270ef9708fed810c37312f2c9.png",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    "Endless Gratitude\n \n DETAILS:\n Blank inside\n Foil details\n Size: A2 folded 4.25” x 5.5”\n Envelope: open end with multi-color flecks",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:18.463Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
